import React, { memo, ReactNode } from 'react';

export interface StrangerProfileAttributeRowProps {
    icon: ReactNode;
    label: string;
    value: string;
}

export const StrangerProfileAttributeRow = memo(({ icon, label, value }: StrangerProfileAttributeRowProps) => (
    <div className="stranger-profile__attribute-row">
        <div className="stranger-profile__attribute-icon">{icon}</div>
        <span className="stranger-profile__attribute-label">{label}</span>
        <span className="stranger-profile__attribute-value">{value}</span>
    </div>
));

export default StrangerProfileAttributeRow;
